<template>
    <div>
        <table class="trade-state-related-setting-table" cellspacing="0" cellpadding="0">
            <thead>
                <tr>
                    <th colspan="2"></th>
                    <th class="fin-analysis" v-show="showFinAnalysis">財務分析</th>
                    <th class="income-state" v-show="showIncomeState">綜合損益表</th>
                    <th class="balance" v-show="showBalance">資產負債表</th>
                </tr>
            </thead>
            <draggable v-model="currItems" tag="tbody" handle=".handler" @change="onSortingChanged" animation="300">
                <tr v-for="item in currItems" :key="item.sno">
                    <td class="handle">
                        <div class="handler"></div>
                    </td>
                    <td class="name">{{ item.iteM_NAM }}</td>
                    <td class="fin-analysis" v-show="showFinAnalysis">
                        <el-cascader v-model="item.finSno" :options="finAnalysisItems" placeholder="請選擇" size="small"> </el-cascader>
                    </td>
                    <td class="income-state" v-show="showIncomeState">
                        <el-select v-model="item.incomeSno" placeholder="請選擇" size="small">
                            <el-option v-for="item in incomeSheetItems" placeholder="請選擇" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                        </el-select>
                    </td>
                    <td class="balance" v-show="showBalance">
                        <el-cascader v-model="item.balanceSno" :options="balanceSheetItems" placeholder="請選擇" size="small"> </el-cascader>
                    </td>
                </tr>
            </draggable>
        </table>
    </div>
</template>
<script>
import { incomeStateSheetItems } from '@/assets/commonData/options';
import draggable from 'vuedraggable';

export default {
    name: 'trade-state-related-setting-table',
    components: {
        draggable,
    },
    props: {
        group: {
            type: String,
            default: null,
        },
        showFinAnalysis: {
            type: Boolean,
            default: true,
        },
        showIncomeState: {
            type: Boolean,
            default: true,
        },
        showBalance: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isLoading: false,
            allItems: {
                payoutSettings: [],
                invoiceSettings: [],
                cInSettings: [],
                cOutSettings: [],
                cInElseSettings: [],
                cOutElseSettings: [],
            },
        };
    },
    watch: {
        group(newValue) {
            console.log(newValue);
        },
    },
    created() {
        this.$store.dispatch('financialAnalysisItems/updateFinancialAnalysisItems');
        this.$store.dispatch('balanceItems/updateBalanceItems');

        this.isLoading = true;

        this.$api({
            url: 'Tool/GetIncomeStatementSettings',
            method: 'GET',
        })
            .then((resp) => {
                this.allItems.payoutSettings = resp.data.payoutSettings;
                this.allItems.invoiceSettings = resp.data.invoiceSettings;
                this.allItems.cInSettings = resp.data.cInSettings;
                this.allItems.cOutSettings = resp.data.cOutSettings;
                this.allItems.cInElseSettings = resp.data.cInElseSettings;
                this.allItems.cOutElseSettings = resp.data.cOutElseSettings;
            })
            .finally(() => {
                this.isLoading = false;
            });
    },
    computed: {
        currItems() {
            return this.allItems[this.group];
        },
        finAnalysisItems() {
            return this.$store.getters['financialAnalysisItems/financialAnalysisItems'];
        },
        incomeSheetItems() {
            return incomeStateSheetItems;
        },
        balanceSheetItems() {
            return this.$store.getters['balanceItems/balanceItems'];
        },
    },
    methods: {
        onSortingChanged() {},
    },
};
</script>
<style lang="scss">
.trade-state-related-setting-table {
    $line-color: #ddd;
    $fin-analysis-color: red;
    $income-state-color: orange;
    $balance-color: blue;

    width: 100%;
    border-top: 1px solid $line-color;
    border-left: 1px solid $line-color;

    th {
        border-bottom: 2px solid $line-color;
        border-right: 1px solid $line-color;
        padding: 5px 5px;
        white-space: nowrap;
        font-size: 11pt;

        &.fin-analysis {
            border-bottom: 2px solid $fin-analysis-color;
        }
        &.income-state {
            border-bottom: 2px solid $income-state-color;
        }
        &.balance {
            border-bottom: 2px solid $balance-color;
        }
    }

    td {
        border-bottom: 1px solid $line-color;
        border-right: 1px solid $line-color;
        padding: 3px 5px;

        .el-cascader,
        .el-select {
            width: 100%;
        }
    }
    td.handle {
        width: 30px;
        border-right: 0;
        padding-right: 0;

        .handler {
            position: relative;
            width: 20px;
            height: 20px;
            background-color: transparent;
            border-radius: 3px;
            cursor: move;

            &:hover {
                background-color: #f4f4f4;
            }

            &:before {
                position: absolute;
                top: 7px;
                left: 5px;
                content: "";
                width: 10px;
                height: 2px;
                background-color: #ccc;
            }

            &:after {
                position: absolute;
                top: 11px;
                left: 5px;
                content: "";
                width: 10px;
                height: 2px;
                background-color: #ccc;
            }
        }
    }
    td.name {
        white-space: nowrap;
        font-size: 11pt;
        padding-right: 13px;
    }
    td.fin-analysis {
        min-width: 180px;
    }
    td.income-state {
        min-width: 130px;
    }
    td.balance {
        min-width: 230px;
    }
}
</style>
